module.exports = __webpack_public_path__ + "static/media/3.0c85effd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/3.png
// module id = 1179
// module chunks = 0